import { render, staticRenderFns } from "./nested-tree.vue?vue&type=template&id=ff8f06b4&scoped=true&"
import script from "./nested-tree.vue?vue&type=script&lang=js&"
export * from "./nested-tree.vue?vue&type=script&lang=js&"
import style0 from "./nested-tree.vue?vue&type=style&index=0&id=ff8f06b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8f06b4",
  null
  
)

export default component.exports